import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {ApartmentTypes, ApartmentTypesSearchParams} from '@association/_common/models/apartments.models';

export const LoadList = createAction(
    '[ApartmentsTypes] Load List',
    props<{ payload: { loading: DahLoadingType } }>()
);

export const LoadListSuccess = createAction(
    '[ApartmentsTypes] Load List Success',
    props<{ payload: { items: ApartmentTypes[], pagination: DahPaginationModel } }>()
);

export const LoadListFailure = createAction(
    '[ApartmentsTypes] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[ApartmentsTypes] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[ApartmentsTypes] Set Filter',
    props<{ payload: ApartmentTypesSearchParams }>()
);

export const SetLoading = createAction(
    '[ApartmentsTypes] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[ApartmentsTypes] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[ApartmentsTypes] Update Item Success',
    props<{ payload: ApartmentTypes }>()
);

export const DeleteItem = createAction(
    '[ApartmentsTypes] Delete Item',
    props<{ payload: ApartmentTypes }>()
);

export const DeleteItemSuccess = createAction(
    '[ApartmentsTypes] Delete Item Success',
    props<{ payload: { item: ApartmentTypes, deleted: boolean } }>()
);

export const DeleteItemFailure = createAction(
    '[ApartmentsTypes] Delete Item Failure',
    props<{ payload: ApartmentTypes }>()
);

export const SetInitialState = createAction(
    '[ApartmentsTypes] Set Initial State'
);
